// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.demo-ruleForm[data-v-6a1716cf]{\n  padding: 32px 0 32px 32px;\n}\n\n", ""]);
// Exports
module.exports = exports;
